import PropTypes from 'prop-types';
import Iconify from 'src/components/Iconify';
import { Input } from 'src/@/components/ui/input';
import { Button } from 'src/@/components/ui/button';
import { cn } from 'src/@/lib/utils';

DrawerNegocioNotasInput.propTypes = {
  disabled: PropTypes.bool,
  onSend: PropTypes.func,
  changeText: PropTypes.func,
  text: PropTypes.string
};

export default function DrawerNegocioNotasInput({ disabled, changeText, text, onSend, className, ...other }) {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (text?.trim()) {
        onSend?.();
      }
    }
  };

  return (
    <div
      className={cn(
        'flex items-center gap-1 pl-4 pr-1.5 py-1 rounded-xl border border-gray-200 dark:border-[#383838]',
        'bg-white dark:bg-[#1A1D21] transition-all',
        'focus-within:border-[#7C3AED] focus-within:ring-2 focus-within:ring-[#7C3AED]/20',
        className
      )}
      {...other}
    >
      <Input
        value={text || ''}
        onChange={(e) => changeText?.(e)}
        onKeyDown={handleKeyDown}
        disabled={disabled}
        placeholder="Escreva um comentário…"
        className="flex-1 h-9 px-0 border-0 shadow-none bg-transparent text-sm focus-visible:ring-0 placeholder:text-gray-400 dark:placeholder:text-[#ABABAD]/60 dark:text-[#D1D2D3]"
      />
      <Button
        size="icon"
        variant="ghost"
        disabled={!text?.trim() || disabled}
        onClick={onSend}
        title="Enviar comentário"
        className="h-8 w-8 rounded-lg text-[#7C3AED] hover:bg-violet-50 hover:text-[#6d28d9] dark:hover:bg-violet-500/10 disabled:text-gray-300 dark:disabled:text-[#565856]"
      >
        <Iconify className="w-4 h-4" icon="mdi:send" />
      </Button>
    </div>
  );
}
